import { useState, useEffect } from "react";
import { getCurrentMailItem, getItemBody } from "../services/outlook";

export interface MailboxItem {
  subject?: string;
  senderEmail?: string;
  senderName?: string;
  body?: string;
}

export function useMailbox(): MailboxItem | null {
  const [item, setItem] = useState<MailboxItem | null>(null);

  useEffect(() => {
    const mailItem = getCurrentMailItem();
    if (mailItem) {
      const base: MailboxItem = {
        subject: mailItem.subject,
        senderEmail: mailItem.from?.emailAddress,
        senderName: mailItem.from?.displayName,
      };
      setItem(base);

      getItemBody(Office.CoercionType.Text)
        .then((body) => setItem((prev) => (prev ? { ...prev, body } : prev)))
        .catch(() => {
          // Body not available — leave undefined
        });
    }
  }, []);

  return item;
}
